import { API_ROUTE } from '../constants/route.constant'

const appConfig = {
    apiPrefix: API_ROUTE,
    authenticatedEntryPath: '/app/dashboard',
    appEntryPath: '/app/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'fr',
    enableMock: false
}

export default appConfig
